import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDecisionType } from './idecision-type.model';
import { GlobalRef } from 'src/app/shared/globals/global-ref';
import { DictionaryBaseService } from 'src/app/shared/services/dictionary-base.service';
import { UserContextService } from 'src/app/shared/services/user-context.service';
import { IEntityValidation } from 'src/app/shared/interfaces/models/ientity-validation.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DecisionTypeService extends DictionaryBaseService<IDecisionType> {
  constructor(
    globalContext: GlobalRef,
    protected userContextSvc: UserContextService,
    protected http: HttpClient
  ) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += 'DecisionTypes/';
  }

  getTemplateNames(): Observable<string[]> {
    return this.http.get<string[]>(this.svcUrl + 'GetTemplateNames');
  }

  validate(model: IDecisionType): IEntityValidation {
    const res: IEntityValidation = { Valid: true, FieldErrors: {} };
    const fieldErrors = res.FieldErrors;

    if (!model.Title || model.Title.trim().length <= 0) {
      fieldErrors['Title'] = 'Введите название';
    }
    if (!model.UseCurrentOrgUnitContext && (!model.COECSecretaryGroupId || model.COECSecretaryGroupId <= 0)) {
      fieldErrors['Group'] = 'Группа не выбрана';
    }
    if (!model.DecisionIdeaStatuses || model.DecisionIdeaStatuses.length < 1) {
      fieldErrors['DecisionIdeaStatuses'] = 'Статусы идей для решений не выбраны';
    }
    if (!model.TemplateName) {
      fieldErrors['TemplateName'] = 'Шаблон протокола не выбран';
    }
    if (!model.WorkflowId) {
      fieldErrors['WorkflowId'] = 'РП не выбран';
    }

    if (!model.DecisionRules || model.DecisionRules.length === 0) {
      fieldErrors['DecisionRule'] = 'Настройки статусов решений созданы';
    }
    if (model.DecisionRules && model.DecisionRules.length > 0) {
      if (model.DecisionRules.some((e) => !e.ActivityEventTypeId || !e.IdeaStatusId)) {
        fieldErrors['DecisionRule'] = 'Настройки статусов решений не заполнены';
      }

      if (
        model.DecisionRules.some(
          (e) => e.Settings.Assignment.Enabled && !e.Settings.Assignment.Type
        )
      ) {
        fieldErrors['Assignment'] = 'Тип назначения не выбран';
      }

      const rulesWithNotifications = model.DecisionRules.filter(
        (r) => r.Settings.Notification.Enabled
      );

      for (let rule of rulesWithNotifications) {
        const recipients = rule.Settings.Notification.Recipients;
        const templates = rule.Settings.Notification.Templates;

        if (!recipients.IdeaAuthor && !recipients.SECOU) {
          fieldErrors['Recipients'] = 'Получатели уведомленяи не выбраны';
        }

        if (recipients.IdeaAuthor && !templates.Author) {
          fieldErrors['MessageTemplate'] = 'Для автора идеи не задан шаблон сообщения';
          break;
        }

        if (recipients.SECOU && !templates.SECOU) {
          fieldErrors['MessageTemplate'] = 'Для СЭС ОЕ не задан шаблон сообщения';
          break;
        }

        if (
          (recipients.IdeaAuthor || recipients.SECOU) &&
          !rule.Settings.Notification.UseIndividualTemplates &&
          !templates.Common
        ) {
          fieldErrors['MessageTemplate'] = 'Общий шаблон сообщения не задан';
          break;
        }
      }
    }

    if (Object.keys(fieldErrors).length > 0) {
      res.Valid = false;
      res.Message = Object.values(fieldErrors).join(';<br>') + '.';
    }

    return res;
  }
}
